<template>
  <div class="block-panel">
    <div class="block-title">{{ title }}</div>
    <div v-if="modelData != null && isProduct == false" class="right-ul">
      <div v-for="(item, index) in modelData" :key="index" class="item">
        <img :src="item.CoverPhoto" alt class="icon" />
        <div class="tit">{{ item.Name }}</div>
      </div>
    </div>
    <div v-else>
      <router-link
        v-for="(item, index) in modelData"
        :key="index"
        :to="{
          path: '/MProductList',
          query: { did: item.DistributionLevelId },
        }"
        class="goods-list"
      >
        <div class="hd">
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            :src="item.CoverPhoto"
          />
        </div>
        <div class="bd">
          <div class="title van-multi-ellipsis--l3">{{ item.Desc }}</div>
          <van-button round class="mybtn" size="small">查看产品</van-button>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    modelData: null,
    isProduct: false,
  },
};
</script>
<style scoped>
.block-panel {
  background: #fff;
  margin-bottom: 8px;
}
.block-title {
  font-size: 16px;
  color: #666;
  padding: 15px 15px 6px;
}
.right-ul {
  overflow: hidden;
}
.right-ul .item {
  width: 33.3333333333%;
  padding: 15px;
  display: inline-block;
  vertical-align: top;
}
.right-ul .item .icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.right-ul .item .tit {
  font-size: 13px;
  color: #444;
  text-align: center;
  margin-top: 8px;
  line-height: 1.4;
}
.goods-list {
  display: flex;
  align-items: center;
  padding: 15px;
}
.goods-list > .hd {
  width: 105px;
  height: 105px;
  margin-right: 14px;
}
.goods-list > .bd {
  flex: 1;
  overflow: hidden;
}
.goods-list > .bd .title {
  overflow: hidden;
  font-size: 14px;
  color: #444;
  line-height: 1.4;
  margin-bottom: 8px;
}
</style>
